import {
  getField
} from 'vuex-map-fields';

export default {
  getField,

  autoCompleteGetData: state => {
    return {
      params: {
        q: state.where,
        date: state.when,
        type: state.how,
        departure: state.departure
      }
    };
  }
}